import { ICustomAnimationProps } from "components/Animations/CustomAnimation";
import theme from "theme";

export const backgroundAnimations: ICustomAnimationProps = {
  type: "fade",
  delay: 1,
  delayOut: 1000,
  timeout: { enter: 500, exit: 250 },
  direction: "down",
  easing: theme.transitions.easing.easeInOut,
};

export const searchHeaderAnimations: ICustomAnimationProps = {
  type: "collapse",
  delay: 250,
  delayOut: 500,
  timeout: { enter: 250, exit: 200 },
  direction: "down",
  mountOnEnter: true,
  easing: theme.transitions.easing.easeIn,
};

export const titleBoxAnimations: ICustomAnimationProps = {
  type: "grow",
  delay: 600,
  delayOut: 350,
  timeout: { enter: 250, exit: 250 },
  easing: theme.transitions.easing.easeIn,
};

export const discountTextBoxAnimations: ICustomAnimationProps = {
  type: "grow",
  delay: 650,
  delayOut: 400,
  timeout: { enter: 250, exit: 100 },
  easing: theme.transitions.easing.easeIn,
};

export const youthStudentSwitchAnimations: ICustomAnimationProps = {
  type: "collapse",
  delay: 700,
  delayOut: 200,
  timeout: { enter: 200, exit: 100 },
  easing: theme.transitions.easing.easeIn,
};

export const lowPriceCalendarAnimations: ICustomAnimationProps = {
  type: "fade",
  delay: 750,
  delayOut: 100,
  timeout: { enter: 250, exit: 250 },
  easing: theme.transitions.easing.easeIn,
};

export const skeletonAnimation: ICustomAnimationProps = {
  type: "fade",
  delay: 750,
  delayOut: 1000,
  timeout: { enter: 250, exit: 250 },
  easing: theme.transitions.easing.easeIn,
};

export const flightCardAnimations: ICustomAnimationProps = {
  type: "fade",
  timeout: { enter: 500, exit: 250 },
  delay: 0,
  delayOut: 0,
  easing: theme.transitions.easing.easeIn,
};

export const navigateDelay = 1000;
